import { compose, onlyUpdateForKeys, withHandlers } from 'recompose';
import withLifecycle from '@hocs/with-lifecycle';
import { ApiClient } from 'services';
import { isArray, isObject } from 'lodash';

const enhance = compose(
  onlyUpdateForKeys([
    'ordering',
    'path',
    'offset',
    'limit',
    'search',
    'refreshToken',
    'filters',
  ]),
  withHandlers({
    fetch: ({
      url,
      ordering: tmpOrdering,
      offset,
      limit,
      filters,
      onDataFetched,
      search,
      onLoaded,
      filterType = null,
      filterValue = null,
    }) => () => {
      console.log({url});
      console.log({filters});
      const ordering = tmpOrdering.column
        ? `${tmpOrdering.direction === 2 ? '-' : ''}${tmpOrdering.column}`
        : '';

      let params = { ordering, offset, limit, search };
      if (filterType !== null) {
        params[filterType] = filterValue;
      }
      if (isObject(filters)) {
        params = {
          ...params,
          ...filters,
        };
      }

      const client = ApiClient();
      client
        .get(url, {
          params,
        })
        .tap(({ data }) => {
          if (isArray(data)) {
            onDataFetched({ count: 0, results: data });
          } else {
            onDataFetched(data);
          }

          if(!!onLoaded){
            onLoaded(false);
          }
          
        });
    },
  }),
  withLifecycle({
    onDidMount: ({ fetch }) => fetch(),
    onWillUpdate: ({ fetch }) => fetch(),
  })
);

export const TableDataFetch = () => null;

export default enhance(TableDataFetch);



// WEBPACK FOOTER //
// ./src/components/common/Tables/TableDataFetch.js